import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { BehaviorSubject } from 'rxjs';
import { EstadoSolicitud } from 'src/app/models/common/enumModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';

@Component({
  selector: 'app-solicitud-master-progress',
  templateUrl: './solicitud-master-progress.component.html',
  styleUrls: ['./solicitud-master-progress.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SolicitudMasterProgressComponent implements OnInit {

  @Input() model!: ISolicitudModel;
  @Input() flujoCompleto: boolean = true;
  private _data = new BehaviorSubject<ISolicitudModel>(new SolicitudModel());

  // change data to use getter and setter
  @Input()
  set data(value: ISolicitudModel) {
    // set the latest value for _data BehaviorSubject
    this._data.next(value);
  };

  get data() {
    // get the latest value from _data BehaviorSubject
    return this._data.getValue();
  }
  public completedSolicitado: boolean;
  public completedRevision: boolean;
  public completedProgramacion: boolean;
  public completedResultados: boolean;
  public completedAutorizacion: boolean;
  public completedFinalizado: boolean;
  // public flujoCompleto: boolean;
  public stepIndex: number;
  constructor() {
    this.model = new SolicitudModel();
    this.completedSolicitado = false;
    this.completedRevision = false;
    this.completedProgramacion = false;
    this.completedResultados = false;
    this.completedAutorizacion = false;
    this.completedFinalizado = false;
    // this.flujoCompleto = false;
    this.stepIndex = 0;
  }

  ngOnInit(): void {

    this._data.subscribe(p => {
      // if (this.model.aplicaPersonas) {
      //   this.flujoCompleto = true;
      // }
      switch (this.model.idEstado) {
        case EstadoSolicitud.EN_REVISION:
        case EstadoSolicitud.REVISADO:
        case EstadoSolicitud.OBSERVADO:
        case EstadoSolicitud.RECHAZADO:
          this.stepIndex = 1;
          this.completedSolicitado = true;
          break;
        case EstadoSolicitud.PROGRAMACION_INDUCCION:
          this.stepIndex = 2;
          this.completedSolicitado = true;
          this.completedRevision = true;
          break;
        case EstadoSolicitud.RESULTADOS_INDUCCION:
          this.stepIndex = 3;
          this.completedSolicitado = true;
          this.completedRevision = true;
          this.completedProgramacion = true;
          break;
        case EstadoSolicitud.AUTORIZACION_ACCESOS:
          this.stepIndex = 4;
          this.completedSolicitado = true;
          this.completedRevision = true;
          this.completedProgramacion = true;
          this.completedResultados = true;
          break;
        case EstadoSolicitud.FINALIZADO:
        case EstadoSolicitud.STAND_BY:
          this.stepIndex = 5;
          this.completedSolicitado = true;
          this.completedRevision = true;
          this.completedProgramacion = true;
          this.completedResultados = true;
          this.completedAutorizacion = true;
          this.completedFinalizado = true;
          break;
        default:
          break;
      }
    });


  }

  ngAfterViewInit(): void {
    // this.stepper.selectedIndex = this.stepIndex;
  }
}
